"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseFactory = exports.PaygwResultStrategy = exports.UserApiResultStrategy = exports.OpenApiResultStrategy = exports.CCApiResultStrategy = exports.WecomMsgResultStrategy = exports.SellerApiResultStrategy = exports.BuyerApiResultStrategy = exports.ServerApiPaginResultStrategy = exports.ServerApiResultStrategy = exports.DefaultResultStrategy = void 0;
const types_1 = require("../types");
const _1 = require(".");
const utils_1 = require("./utils");
const ResponseConfig_1 = require("./ResponseConfig");
const hub_utilities_is_1 = require("@yw/hub.utilities.is");
class DefaultResultStrategy {
    createResponseResult(response) {
        const code = (0, utils_1.getEndpointStatusCode)(response.status);
        return new _1.ResponseResult(code, (0, utils_1.isSuccessfulStatusCode)(code), (0, utils_1.getEndpointStatusMessage)(code), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)());
    }
}
exports.DefaultResultStrategy = DefaultResultStrategy;
class ServerApiResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.customCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        let resp = ((_d = response.config) === null || _d === void 0 ? void 0 : _d.rawData) ? response.data : (0, utils_1.getEndpointData)(response.data);
        if ((_e = response.config) === null || _e === void 0 ? void 0 : _e.rawStatusCode) {
            const rawStatusCode = (_f = response.data) === null || _f === void 0 ? void 0 : _f.code;
            if ((0, hub_utilities_is_1.isNullOrUnDef)(resp)) {
                resp = { rawStatusCode };
            }
            else if ((0, hub_utilities_is_1.isArray)(resp)) {
                resp = { data: resp, rawStatusCode };
            }
            else if ((0, hub_utilities_is_1.isObject)(resp)) {
                resp = Object.assign(Object.assign({}, resp), { rawStatusCode });
            }
        }
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)(((_g = response.data) === null || _g === void 0 ? void 0 : _g.message) || ((_h = response.data) === null || _h === void 0 ? void 0 : _h.msg) || ((_j = response.data) === null || _j === void 0 ? void 0 : _j.errors), standardCode), resp, (0, utils_1.getUniqueId)((_k = response.data) === null || _k === void 0 ? void 0 : _k.requestId));
    }
}
exports.ServerApiResultStrategy = ServerApiResultStrategy;
class ServerApiPaginResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e, _f, _g;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.customCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        const { total, current_page } = response.data;
        const rep = {
            list: (0, utils_1.getEndpointData)(response.data, true),
            [types_1.PagingEnum.PAGE]: current_page,
            [types_1.PagingEnum.PAGE_SIZE]: 10,
            [types_1.PagingEnum.TOTAL]: total || 0,
            totalPage: total || 0,
        };
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)(((_d = response.data) === null || _d === void 0 ? void 0 : _d.message) || ((_e = response.data) === null || _e === void 0 ? void 0 : _e.msg) || ((_f = response.data) === null || _f === void 0 ? void 0 : _f.errors), standardCode), rep, (0, utils_1.getUniqueId)((_g = response.data) === null || _g === void 0 ? void 0 : _g.requestId));
    }
}
exports.ServerApiPaginResultStrategy = ServerApiPaginResultStrategy;
class BuyerApiResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e, _f, _g;
        const code = (0, utils_1.getEndpointStatusCode)((response === null || response === void 0 ? void 0 : response.status) || '500');
        const { total, page, page_size, success } = response.data || {};
        let pagingResp = {
            list: (0, utils_1.getEndpointData)(response.data, true),
            [types_1.PagingEnum.PAGE]: +(page || 1),
            [types_1.PagingEnum.PAGE_SIZE]: +(page_size || 10),
            [types_1.PagingEnum.TOTAL]: total || 0,
            totalPage: total || 0,
        };
        if ((_a = response.config) === null || _a === void 0 ? void 0 : _a.url.includes('/rfqms/v1/seller/rfqs/user/history')) {
            pagingResp.extras = {
                user: response.data.user
            };
        }
        let handle = true;
        // TODO: 后续想到好的方案再重新设计数据处理策略
        if (['/v2/affiliate/apply/picking_list'].includes((_b = response.config) === null || _b === void 0 ? void 0 : _b.url.split('?')[0])) {
            handle = false;
        }
        let resp;
        if ((_c = response.config) === null || _c === void 0 ? void 0 : _c.rawData) {
            resp = response.data;
        }
        else {
            resp =
                !(0, hub_utilities_is_1.isNullOrUnDef)(total) && (page || page_size)
                    ? pagingResp
                    : handle
                        ? (0, utils_1.getEndpointData)(response.data)
                        : response.data;
        }
        return new _1.ResponseResult(code, success !== null && success !== void 0 ? success : (0, utils_1.isSuccessfulStatusCode)(code), (0, utils_1.getEndpointStatusMessage)(((_d = response.data) === null || _d === void 0 ? void 0 : _d.message) || ((_e = response.data) === null || _e === void 0 ? void 0 : _e.errors) || ((_f = response.data) === null || _f === void 0 ? void 0 : _f.msg), code), resp, (0, utils_1.getUniqueId)((_g = response.data) === null || _g === void 0 ? void 0 : _g.requestId));
    }
}
exports.BuyerApiResultStrategy = BuyerApiResultStrategy;
class SellerApiResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c;
        const code = (0, utils_1.getEndpointStatusCode)(response.status);
        return new _1.ResponseResult(code, (0, utils_1.isSuccessfulStatusCode)(code), (0, utils_1.getEndpointStatusMessage)(((_a = response.data) === null || _a === void 0 ? void 0 : _a.message) || ((_b = response.data) === null || _b === void 0 ? void 0 : _b.errors), code), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)((_c = response.data) === null || _c === void 0 ? void 0 : _c.requestId));
    }
}
exports.SellerApiResultStrategy = SellerApiResultStrategy;
class WecomMsgResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.webcomCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)((_d = response.data) === null || _d === void 0 ? void 0 : _d.msg, standardCode), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)((_e = response.data) === null || _e === void 0 ? void 0 : _e.requestId));
    }
}
exports.WecomMsgResultStrategy = WecomMsgResultStrategy;
class CCApiResultStrategy {
    createResponseResult(response) {
        var _a;
        const code = (0, utils_1.getEndpointStatusCode)(response.status);
        return new _1.ResponseResult(code, (0, utils_1.isSuccessfulStatusCode)(code), (0, utils_1.getEndpointStatusMessage)((_a = response.data) === null || _a === void 0 ? void 0 : _a.errors, code), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)());
    }
}
exports.CCApiResultStrategy = CCApiResultStrategy;
class OpenApiResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e, _f;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.openApiCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)(((_d = response.data) === null || _d === void 0 ? void 0 : _d.message) || ((_e = response.data) === null || _e === void 0 ? void 0 : _e.msg), standardCode), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)((_f = response.data) === null || _f === void 0 ? void 0 : _f.traceId));
    }
}
exports.OpenApiResultStrategy = OpenApiResultStrategy;
class UserApiResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.userCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)((_d = response.data) === null || _d === void 0 ? void 0 : _d.msg, standardCode), (0, utils_1.getEndpointData)(response.data), (0, utils_1.getUniqueId)((_e = response.data) === null || _e === void 0 ? void 0 : _e.requestId));
    }
}
exports.UserApiResultStrategy = UserApiResultStrategy;
class PaygwResultStrategy {
    createResponseResult(response) {
        var _a, _b, _c, _d, _e, _f, _g;
        const code = (0, utils_1.getEndpointStatusCode)((_a = response.data) === null || _a === void 0 ? void 0 : _a.code, response.status, ResponseConfig_1.paygwCodeToEndpointStatusCode);
        const standardCode = (0, utils_1.getEndpointStatusCodeForMethod)(((_b = response.config) === null || _b === void 0 ? void 0 : _b.normalizeMethod) || ((_c = response.config) === null || _c === void 0 ? void 0 : _c.method), code);
        let resp = (0, utils_1.getEndpointData)(response.data);
        if ((_d = response.config) === null || _d === void 0 ? void 0 : _d.rawStatusCode) {
            const rawStatusCode = (_e = response.data) === null || _e === void 0 ? void 0 : _e.code;
            if ((0, hub_utilities_is_1.isNullOrUnDef)(resp)) {
                resp = { rawStatusCode };
            }
            else if ((0, hub_utilities_is_1.isArray)(resp)) {
                resp = { data: resp, rawStatusCode };
            }
            else if ((0, hub_utilities_is_1.isObject)(resp)) {
                resp = Object.assign(Object.assign({}, resp), { rawStatusCode });
            }
        }
        return new _1.ResponseResult(standardCode, (0, utils_1.isSuccessfulStatusCode)(standardCode), (0, utils_1.getEndpointStatusMessage)((_f = response.data) === null || _f === void 0 ? void 0 : _f.msg, standardCode), resp, (0, utils_1.getUniqueId)((_g = response.data) === null || _g === void 0 ? void 0 : _g.requestId));
    }
}
exports.PaygwResultStrategy = PaygwResultStrategy;
class ResponseFactory {
    static createResponse(response, strategy = new DefaultResultStrategy()) {
        return Object.assign(Object.assign({}, response), { data: strategy.createResponseResult(response) });
    }
}
exports.ResponseFactory = ResponseFactory;
//# sourceMappingURL=ResponseFactory.js.map